export const Checkout = () => {
  return <div>This is checkout page.</div>;
};
